/* 022 · Produkt-Spotlight: Scroll-Animation und Warenkorb */
(function () {
  if (window.mmSpotlightInit) return;
  window.mmSpotlightInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function progress(el, start, end) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight;
    var p = (vh * start - r.top) / (r.height + vh * (start - end));
    return Math.min(1, Math.max(0, p));
  }

  function setupAbend(el) {
    return function () {
      // 0 = Abendlicht, sobald die Section halb im Bild ist; 1 = Nacht, kurz nachdem sie die Bildmitte passiert hat
      var p = reduce ? 0.8 : progress(el, 0.6, 0.5);
      el.style.setProperty('--p', p.toFixed(3));
    };
  }

  function setupEtappe(el) {
    var drawn = el.querySelector('[data-mmsp-drawn]');
    var rider = el.querySelector('[data-mmsp-rider]');
    var profile = el.querySelector('.mmsp__profile');
    var beans = el.querySelectorAll('[data-mmsp-bean]:not([data-off])');
    var len = drawn ? drawn.getTotalLength() : 0;
    if (drawn) drawn.style.strokeDasharray = len;
    return function () {
      var p = reduce ? 1 : progress(el, 0.9, 0.3);
      el.style.setProperty('--p', p.toFixed(3));
      if (drawn) {
        drawn.style.strokeDashoffset = (len * (1 - p)).toFixed(1);
        // Das Profil-SVG wird verzerrt skaliert, der Fahrrad-Button nicht: Position in Pixel umrechnen
        var pt = drawn.getPointAtLength(len * p);
        if (rider && profile) {
          var w = profile.clientWidth, x = Math.min(Math.max(pt.x / 1200 * w, 28), w - 28), y = pt.y / 110 * profile.clientHeight;
          rider.style.transform = 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px) translate(-50%, -50%)';
        }
      }
      beans.forEach(function (b, i) { b.classList.toggle('is-on', p > 0.15 + i * 0.15); });
    };
  }

  function setupBuy(form) {
    var variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    var btn = form.querySelector('[data-btn]');
    var msg = form.querySelector('[data-msg]');
    var priceEl = form.querySelector('[data-price]');
    var unitEl = form.querySelector('[data-unit]');
    var euro = function (c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2 }) + ' €'; };
    function current() {
      var o1 = form.querySelector('input[type=radio]:checked') || form.querySelector('input[data-single]');
      var o2 = form.querySelector('select');
      return variants.find(function (v) { return (!o1 || v.o1 === o1.value) && (!o2 || v.o2 === o2.value); });
    }
    function update() {
      var v = current();
      msg.textContent = '';
      if (!v || !v.available) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; return; }
      btn.disabled = false; btn.textContent = 'In den Warenkorb'; btn.classList.remove('is-done');
      priceEl.textContent = euro(v.price);
      unitEl.textContent = v.o1.replace('1000 Gramm', '1 kg').replace(' Gramm', ' g') + (v.unit ? ' · ' + euro(v.unit) + '/' + v.ref : '');
    }
    form.addEventListener('change', update);
    update();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v) return;
      btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble', sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
        .then(function (state) {
          var mini = document.querySelector('mini-cart');
          if (mini && typeof mini.renderContents === 'function' && state.sections) mini.renderContents(state);
          else location.href = '/cart';
          btn.disabled = false; btn.textContent = 'Im Warenkorb ✓'; btn.classList.add('is-done');
          setTimeout(update, 2500);
        })
        .catch(function (err) {
          msg.textContent = 'Das hat nicht geklappt: ' + err.message + ' Bitte versuchen Sie es noch einmal.';
          update();
        });
    });
  }

  function init() {
    var renders = [];
    document.querySelectorAll('[data-mmsp]').forEach(function (el) {
      if (el.dataset.mmspReady) return;
      el.dataset.mmspReady = '1';
      renders.push(el.dataset.style === 'etappe' ? setupEtappe(el) : setupAbend(el));
      el.querySelectorAll('[data-mmsp-buy]').forEach(setupBuy);
    });
    if (!renders.length) return;
    var ticking = false;
    function all() { renders.forEach(function (fn) { fn(); }); }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; all(); }); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    all();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.mmSpotlightInit = true; init(); });
})();
